import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookiesModalComponent } from '../../modals/cookies-modal/cookies-modal.component';
import { WebAnalyticsService } from '../../services/web-analytics/web-analytics.service';

@Component({
  selector: 'app-koekjes',
  imports: [],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss',
})
export class CookiesComponent {
  protected consent = inject(WebAnalyticsService).consent;
  private readonly modalService = inject(NgbModal);
  private readonly webAnalyticsService = inject(WebAnalyticsService);

  protected acceptedClicked(accepted: boolean): void {
    this.webAnalyticsService.setConsent(accepted);
  }

  protected moreInformationClicked(): void {
    this.modalService.open(CookiesModalComponent);
  }
}
